import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Отправьте одну вещь на фотозону ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_MoveMaster = _resolveComponent("MoveMaster")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", null, [
      _hoisted_1,
      (![_ctx.enumProductState.collected, _ctx.enumProductState.described].includes(_ctx.product?.state || 0))
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            size: "40px",
            color: "green"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_check)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isToShooting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MoveMaster, {
            "prop-options": { type: 'nw-h', destination: 2 },
            "data-set": { id: _ctx.product?.id },
            "url-set": "/storage/moving-to-photozone",
            onSuccessMoveMaster: _ctx.success
          }, null, 8, ["data-set", "onSuccessMoveMaster"])
        ]))
      : (_ctx.product?.state === _ctx.enumProductState.shooting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Единица товара на фотозоне"))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "Недоступно редактирование фотозоны"))
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}